import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Button, Card, CardBody, Row, Col } from 'reactstrap';
import {
  confirmable,
  createReactTreeMounter,
  createConfirmationCreater,
  createMountPoint,
} from 'react-confirm';

class Confirmation extends React.PureComponent {
  render() {
    const { proceedLabel, cancelLabel, title, confirmation, proceed, show } =
      this.props;
    return (
      <div className="static-modal">
        <Modal
          isOpen={show}
          backdrop
          keyboard
          zIndex="1100"
          className="bg-primary cta-box text-white"
        >
          <Card className="bg-primary cta-box text-white m-0">
            <CardBody>
              <Row className="text-center">
                <Col md="12">
                  <Row>
                    <Col md="12">
                      <h4>{title}</h4>
                      <strong>{confirmation}</strong>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        id="confirmationCancel"
                        color="outline-light"
                        className="btn btn-outline-light btn-sm m-1"
                        onClick={() => proceed(false)}
                      >
                        {cancelLabel}
                      </Button>
                      <Button
                        id="confirmationOk"
                        color="outline-light"
                        className="btn btn-outline-light btn-sm m-1"
                        onClick={() => proceed(true)}
                      >
                        {proceedLabel}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Modal>
      </div>
    );
  }
}

const mounter = createReactTreeMounter();
const createConfirmation = createConfirmationCreater(mounter);

Confirmation.propTypes = {
  proceedLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  proceed: PropTypes.func.isRequired,
  title: PropTypes.string,
  confirmation: PropTypes.string.isRequired,
};

Confirmation.defaultProps = {
  proceedLabel: 'Ja',
  cancelLabel: 'Nej',
  title: '',
};

// eslint-disable-next-line import/prefer-default-export
export function confirm(
  confirmation = '',
  proceedLabel = 'Ja',
  cancelLabel = 'Nej',
  options = {},
) {
  return createConfirmation(confirmable(Confirmation))({
    confirmation,
    proceedLabel,
    cancelLabel,
    ...options,
  });
}

export const MountPoint = createMountPoint(mounter);
